import axios from 'axios';
/**
 * Axios errors out with 'time out of 0 ms exceeded' in certain scenarios. This improves that error message.
 * See: https://github.com/axios/axios/issues/2103
 */
async function axiosRequestImprovedErrorHandling(request) {
    try {
        const response = await request;
        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            if (!error.response || error.code === 'ECONNABORTED') {
                throw new Error(`Network error: Failed to make a network request to endpoint, please check your network connection. Code: ${error.code}`);
            }
        }
        throw error;
    }
}
export { axiosRequestImprovedErrorHandling };
